// src/app/services/[service]/components/game/GamePlatforms.jsx
import React from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "./PlatformsSection.module.css";

export default function GamePlatforms() {
  return (
    <section className={`${styles.section} py-5 py-lg-6`}>
      <div className="container">
        <div className="row g-4 align-items-center">
          {/* Left: Copy + CTA */}
          <div className="col-12 col-lg-4">
            <span className={styles.eyebrow}>Platforms</span>
            <h2 className={`${styles.title} h2 mt-2`}>Key Platforms Where Our Games Thrive</h2>
            <p className={`${styles.lead} mt-3`}>From the power of PCs to the portability of mobile, our expertise creates games across all the platforms.</p>
            <Link href="/contact" className={`${styles.btn} mt-4 d-inline-flex align-items-center gap-2`} aria-label="Connect with us">
              Connect with us! <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
            </Link>
          </div>

          {/* Middle: Image */}
          <div className="col-12 col-lg-4">
            <div className={styles.imageFrame}>
              <Image
                src="/assets/img/gamesimg/game-platform.webp"
                alt="Gamer playing on multiple platforms"
                width={800}
                height={1000}
                className="img-fluid w-100 h-auto"
                priority={false}
              />
            </div>
          </div>

          {/* Right: Platform bullets */}
          <div className="col-12 col-lg-4">
            <div className="d-flex flex-column gap-3">
              <div className={styles.item}>
                <span className={styles.icon}><i className="fa-solid fa-desktop" aria-hidden="true"></i></span>
                <div>
                  <div className={styles.itemTitle}>Computer</div>
                  <p className={styles.itemText}>Captivating games for Windows and macOS with seamless performance and a fantastic experience for desktop players.</p>
                </div>
              </div>

              <div className={styles.item}>
                <span className={styles.icon}><i className="fa-solid fa-gamepad" aria-hidden="true"></i></span>
                <div>
                  <div className={styles.itemTitle}>Console</div>
                  <p className={styles.itemText}>Bring your vision to life on Xbox, Nintendo Switch, and PlayStation to reach gamers worldwide.</p>
                </div>
              </div>

              <div className={styles.item}>
                <span className={styles.icon}><i className="fa-solid fa-mobile-screen" aria-hidden="true"></i></span>
                <div>
                  <div className={styles.itemTitle}>Mobile</div>
                  <p className={styles.itemText}>Outstanding mobile games for iOS and Android with cross‑platform skills to reach a global audience.</p>
                </div>
              </div>

              <div className={styles.item}>
                <span className={styles.icon}><i className="fa-solid fa-vr-cardboard" aria-hidden="true"></i></span>
                <div>
                  <div className={styles.itemTitle}>AR/VR</div>
                  <p className={styles.itemText}>Pushing boundaries with AR/VR to craft unforgettable, immersive experiences.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
